// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BASE_URL: "https://172.104.128.217:3000",
  // BASE_URL: "/",
  proxy: "https://172.104.128.217:3000",
  APP_TOKEN: "APP_TOKEN",
};
